import GlobalPrototypes from '@/config/services/globalPrototypes.ts'
import type { AxiosInstance } from 'axios'

export function useAxios(): { axios: AxiosInstance } {
  if (!GlobalPrototypes.axios) {
    throw new Error('Axios is not initialized in GlobalPrototypes. Please ensure it is set up before using useAxios.')
  }
  return {
    axios: GlobalPrototypes.axios,
  }
}
